/**
 * Chaves de query, em um lugar só.
 *
 * Regra: nenhum literal de chave fora deste arquivo. Os arrays são hierárquicos, do prefixo mais
 * grosso para o mais fino, para que `invalidateQueries({ queryKey: queryKeys.routes.all })` derrube
 * lista e detalhe de uma vez.
 */
export const queryKeys = {
  adhp: {
    all: ['adhp'] as const,
    detail: (code: string) => ['adhp', 'detail', code] as const
  },
  notam: {
    all: ['notam'] as const,
    dataset: () => ['notam', 'dataset'] as const,
    byLocality: (code: string) => ['notam', 'locality', code] as const
  },
  procedures: {
    all: ['procedures'] as const,
    byAdhp: (code: string) => ['procedures', code] as const
  },
  routes: {
    all: ['routes'] as const,
    list: () => ['routes', 'list'] as const,
    detail: (id: string) => ['routes', 'detail', id] as const
  },
  aircrafts: {
    all: ['aircrafts'] as const,
    list: () => ['aircrafts', 'list'] as const,
    models: () => ['aircrafts', 'models'] as const
  },
  wb: {
    all: ['wb'] as const,
    templates: () => ['wb', 'templates'] as const,
    profilesByAircraft: (aircraftId: string) => ['wb', 'profiles', aircraftId] as const,
    // O array e ORDENADO de proposito: chave com array fora de ordem e fonte classica de cache miss
    // silencioso, e ha consumidor que passa `models.map((m) => m.id)`.
    profilesByModels: (modelIds: string[]) => ['wb', 'profilesByModels', [...modelIds].sort()] as const,
    fills: () => ['wb', 'fills'] as const,
    defaultWeights: () => ['wb', 'defaultWeights'] as const
  },
  userContent: {
    all: ['userContent'] as const,
    charts: () => ['userContent', 'charts'] as const,
    geometries: () => ['userContent', 'geometries'] as const,
    waypoints: () => ['userContent', 'waypoints'] as const
  },
  meteorology: {
    all: ['meteorology'] as const,
    manifest: (layer: string) => ['meteorology', 'manifest', layer] as const
  },
  fuel: {
    all: ['fuel'] as const,
    providers: () => ['fuel', 'providers'] as const
  },
  account: {
    all: ['account'] as const,
    dataUpdate: () => ['account', 'dataUpdate'] as const,
    news: () => ['account', 'news'] as const
  }
} as const
